import { render, staticRenderFns } from "./order_wrapper.vue?vue&type=template&id=39ba7a2c&scoped=true&"
import script from "./order_wrapper.vue?vue&type=script&lang=js&"
export * from "./order_wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ba7a2c",
  null
  
)

export default component.exports